import React from 'react';
import HeroSection from '../components/HeroSection';

const LandingPage = () => {
  return (
    <div className="overflow-x-hidden">
      <HeroSection />
    </div>
  );
};

export default LandingPage;
